import React from 'react'
import { HowItWorksWrapper } from '../components/how-it-works/styles'
import Header from '../components/how-it-works/Header'
import Steps from '../components/how-it-works/Steps'
import Prepping from '../components/how-it-works/Prepping'
import TrueBeauty from '../components/how-it-works/TrueBeauty'
import Cancellation from '../components/how-it-works/Cancellation'
// import KristinEss from '../components/how-it-works/KristinEss'

const HowItWorks = () => {
  return (
    <HowItWorksWrapper>
      <Header />
      <Steps />
      <Prepping />
      {/* <KristinEss /> */}
      <TrueBeauty />
      <Cancellation />
    </HowItWorksWrapper>
  )
}


export const getServerSideProps = async () => {
  return { props: {} }
}

export default HowItWorks
